module.exports = __WEBPACK_EXTERNAL_MODULE_angular_sanitize__;